import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import routes from './router/routes'
import './styles.scss'
import VModal from 'vue-js-modal'


Vue.use(VModal)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueRouter)

const router = new VueRouter({
  routes
});

new Vue({
  render: h => h(App),
  router: router
}).$mount('#app')
